<template>
    <div class="budget-item-grid">
        <!--<MDBAccordion v-model="open">
            <MDBAccordionItem
            headerTitle="spending categories"
            collapseId="spending_categories"
            >-->
        <!--<h4 class="budget-item-grid-title">spending categories</h4>-->
        <div style="display: flex; flex-direction: column; height: 100%">
            <div style="width: 100%; flex: 1 1 auto;">
                <ag-grid-vue
                    class="ag-theme-alpine"
                    :columnDefs="columnDefs"
                    :rowData="griddata"
                    :style="{ height: height }"
                    :rowSelection="{ mode: 'singleRow', checkboxes: false, headerCheckbox: false, enableClickSelection: true, enableSelectionWithoutKeys: true }"
                    @gridReady="onGridReady"
                    :overlayLoadingTemplate="overlayLoadingTemplate"
                    @selection-changed="onSelectionChanged"
                    @rowDataUpdated="onRowDataUpdated"
                    :loading="loading"
                    @gridSizeChanged="onGridSizeChanged"
                    :rowHeight="rowHeight"
                >
                </ag-grid-vue> 
            </div>
            </div>
            <!-- </MDBAccordionItem>
            </MDBAccordion>  -->
        </div>
</template>


<script>

import { AgGridVue } from "ag-grid-vue3";
import { MDBAccordion, MDBAccordionItem } from "mdb-vue-ui-kit";
import { ref } from "vue"

export default {
    name: 'CategoryGrid',
    props: {
        data: Array,
        loading: Boolean,
    },
    components: {
      AgGridVue,
      MDBAccordion,
      MDBAccordionItem
    },
    emits: ['category-selected'],
    data() {
        let rowHeight = 84;
        return {
            open: "spending_categories",
            rowHeight: rowHeight,
            griddata: [],
            gridApi: ref(null),
            height: "200px",    
            overlayLoadingTemplate: null,
            shiftDown: null,
            deleteDown: null,            
            columnDefs: [
                { 
                    colId: 'id',
                    headerName: '',
                    field: 'id',
                    resizable: true, 
                    flex: 1, 
                    editable: false,
                },
                { 
                    colId: 'category',
                    headerName: 'Category',
                    field: 'display_name',
                    sortingOrder: ["desc", "asc"], 
                    sortable: true, 
                    filter: true,
                    flex: 3,
                    editable: false,
                },
                { 
                    colId: 'spent',
                    field: 'spent',
                    headerName: "Spent",
                    sortable: true, 
                    filter: true, 
                    resizable: true, 
                    flex: 2, 
                    editable: false,
                    valueGetter: this.spentGetter,
                    valueFormatter: '"$" + Number(value).toFixed(2)',
                    cellStyle: params => {
                        if (window.innerWidth < 800) {
                            if (params.data.spent - params.data.budgeted < 0) {
                                return { color: 'green'};
                            }
                            else if (params.data.spent - params.data.budgeted > 0) {
                                return { color: 'red'};
                            }
                        }

                        return null;
                    }
                },
                { 
                    colId: 'budgeted',
                    headerName: 'Budgeted',
                    field: 'budgeted',
                    sortable: true, 
                    filter: true, 
                    resizable: true, 
                    flex: 2, 
                    editable: false,
                    valueGetter: this.budgetedGetter,
                    valueFormatter: '"$" + Number(value).toFixed(2)',
                },
                { 
                    colId: 'difference',
                    field: 'difference', 
                    headerName: '',
                    sortable: true, 
                    filter: true,
                    valueGetter: this.differenceGetter,
                    valueFormatter: '"$" + Number(value).toFixed(2)',
                    flex: 2, 
                    editable: false, 
                    cellStyle: params => {
                        if (params.value > 0) {
                            return { color: 'green'};
                        }
                        else if (params.value < 0) {
                            return { color: 'red'};
                        }

                        return null;
                    }
                },
                
            ],
        }
    },
    methods: {
        onGridSizeChanged(params) {
            if (params.clientWidth < 800) {
                 this.gridApi.setColumnsVisible(['id', 'difference'], false);
            }
            else {
                this.gridApi.setColumnsVisible(['id', 'difference'], true);
            }
            this.calculateHeightAndTotal();
        },
        spentGetter(params) {
            if (!params.data.spent) {
                return 0;
            }
            return params.data.spent;
        },
        budgetedGetter(params) {
            if (!params.data.budgeted) {
                return 0;
            }
            return params.data.budgeted;
        },
        differenceGetter(params) {
            if (!params.data.spent) {
                return params.data.budgeted;
            }
            if (!params.data.budgeted) {
                return 0;
            }
            return params.data.budgeted - params.data.spent;
        }, 
        onGridReady(params) {
            this.gridApi = params.api;
        },
        onSelectionChanged(event) {
            console.log("Event:")
            console.log(event);
            if (event.source === 'rowDataChanged') {
                let nodesToSelect = [];
                this.gridApi.forEachNode((node) => {
                    if (this.selected_category == node.data) {
                        nodesToSelect.push(node);
                    }
                });
                if (nodesToSelect.length > 0) {
                    this.gridApi.setNodesSelected({
                        nodes: nodesToSelect,
                        // Set to true to select them, false to deselect
                        newValue: true
                    });
                }

            }
            if (this.gridApi.getSelectedRows().length === 1) {
                this.selected_category = this.gridApi.getSelectedRows()[0];
            }
            else {
                this.selected_category = null;
            }
            console.log("Emitting selected category:");
            this.$emit('category-selected', this.selected_category);
        },
        onRowDataUpdated() {
            this.calculateHeightAndTotal();
        },
        generatePinnedData() {

            // generate a row-data with null values
            let result = { 'spent': 0, 'budgeted': 0, 'difference': 0 };
            if (!this.gridApi) {
                return result;
            }
            this.gridApi.getColumns().forEach(item => {
                result[item.colId] = null;
            });
            return this.calculatePinnedData(result);
        },
        calculatePinnedData(target) {
            //**list of columns for aggregation**
            let columnsWithAggregation = ['spent', 'budgeted', 'difference'];
            columnsWithAggregation.forEach(element => {
                target[element] = 0;
                this.gridApi.forEachNodeAfterFilter((rowNode) => {
                    if (rowNode.data[element]) {
                        target[element] += rowNode.data[element];
                    }
                });
            })
            return target;
        },
        calculateHeightAndTotal() {
            this.height = (this.rowHeight * (this.griddata.length + 2) + 10).toString() + "px";
            let pinnedBottomData = this.generatePinnedData();
            this.gridApi?.setGridOption('pinnedTopRowData', [pinnedBottomData]);
        },
        sortCategories(categories) {
            return categories.sort((a, b) => {
                // other should always be at the bottom
                if (a.name == 'other') {
                    return 1;
                }
                if (b.name == 'other') {
                    return -1;
                }

                // otherwise sort by budget size
                if (a.budgeted > b.budgeted) {
                    return -1;
                }
                if (a.budgeted < b.budgeted) {
                    return 1;
                }
                return 0;
            });
        }
    },
    watch: {
        data(newData) {
            this.griddata = this.sortCategories(newData);
            this.calculateHeightAndTotal();
        },
    },
    computed: {
        // Add your computed properties here
    },
    created() {
        this.overlayLoadingTemplate =
            '<span class="ag-overlay-loading-center">Getting categories...</span>';
    },
    updated() {
    }

}
</script>

<style scoped>
    .category-grid {
        /* Add your component styles here */
    }
    .budget-item-grid {
        margin-bottom: 40px;
        margin-top: 10px;   
    }
    .budget-item-grid-title {
        margin-left: 50px;
    }
    .green {
        color: green;
    }
    .red {
        color: red;
    }
</style>